module.exports = __webpack_public_path__ + "static/moe-a97f13ca751920426260a75dcd4915bb.jpg";